import { createReducer, on } from '@ngrx/store';
import {
  addExplorerDataAction,
  setExplorerAvailableDateRangeAction,
  setExplorerDataCurrentRangeAction,
} from './actions';
import { IExplorerDataModel } from './models';

const initial: IExplorerDataModel = {
  explorerData: [],
  range: {
    // 30 days ago. This ugliness per https://stackoverflow.com/a/31665235/947
    minDate: new Date(new Date().setDate(new Date().getDate() - 30)),
    maxDate: new Date(),
  },
};

export const productionExplorerDataReducer = createReducer(
  initial,

  on(addExplorerDataAction, (state, { payload }) => {
    const byDesc = (selector) => (a, b) => selector(b) - selector(a);

    const merged = [...payload, ...state.explorerData];

    const uniqueById = Array.from(new Map(merged.map((item) => [item.id, item])).values());

    return {
      ...state,
      explorerData: uniqueById.sort(byDesc((item) => new Date(item.date).getTime())),
    };
  }),
  on(setExplorerDataCurrentRangeAction, (state) => ({ ...state, explorerData: [] })),
  on(setExplorerAvailableDateRangeAction, (state, { payload }) => ({ ...state, range: payload }))
);
